module.exports = __webpack_public_path__ + "img/video-mobile@2x.e8d5c58.webp";